//  -------------- 插件配置 -------------

import { isInvalid, isString } from '@/modules/validate';

export type ISetPluginOptions = string | ICommonObject<string>;

// 插件链接
export let pluginUrl: ICommonObject<string> = {
  EXIF: '//r.hstong.com/v2/plugins/exif-js/2.3.0/exif.js', // 目前直接取生產
  JSEncrypt: '//r.hstong.com/v2/plugins/jsencrypt/3.0.0-rc.1/jsencrypt.min.js',
  Decimal: '//r.hstong.com/v2/plugins/decimal/10.3.1/decimal.min.js',
  Fetch: '//r.hstong.com/v2/plugins/fetch/3.6.2/fetch.min.js',
  WECHAT: '//res2.wx.qq.com/open/js/jweixin-1.6.0.js',
  Ths: '//s.thsi.cn/cb',
};

// 插件配置修改
export function setPluginUrl(data: ISetPluginOptions) {
  if (isInvalid(data, true)) {
    throw new Error('setPluginUrl参数有误');
  }

  if (isString(data)) {
    for (const key in pluginUrl) {
      // 如果是字符串，则直接替换r.hstong.com
      if (/r\.hstong\.com/.test(pluginUrl[key])) {
        pluginUrl = {
          ...pluginUrl,
          [key]: pluginUrl[key].replace('//r.hstong.com/v2/plugins', data),
        };
      }
    }
    return pluginUrl;
  }

  // 否则合并对象
  pluginUrl = {
    ...pluginUrl,
    ...data,
  };

  return pluginUrl;
}

// 公共插件地址
export function getPluginUrl() {
  return pluginUrl;
}

// ------------ 插件配置 end ---------------
